import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import DealerShipping from 'services/DealerShipping';
import useDealer from './useDealer';
import { useSnackbar } from './useSnackbar';

const useFedexCarrier = () => {
    const openSnackbar = useSnackbar();
    const dealer = useDealer();
    const dealerId = dealer.id;
    const [initialValues, setInitialValues] = useState({
        fedexCarrierEnabled: false,
        fedexCarrierAccountNumber: '',
        fedexCarrierMeterNumber: '',
        fedexCarrierAccountKey: '',
        fedexCarrierPassword: '',
    });

    useEffect(() => {
        if (dealer.id > 0)
            setInitialValues({
                fedexCarrierEnabled: dealer.fedexCarrierEnabled === 1,
                fedexCarrierAccountNumber: dealer.fedexCarrierAccountNumber,
                fedexCarrierMeterNumber: dealer.fedexCarrierMeterNumber,
                fedexCarrierAccountKey: dealer.fedexCarrierAccountKey,
                fedexCarrierPassword: dealer.fedexCarrierPassword
            })
    }, [dealer]);

    const validationSchema = yup.object({

    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            updateFedexCarrier(values);
        },
    });

    const updateFedexCarrier = async (shippingData) => {
        try {
            await DealerShipping.putFedexCarrier({ ...shippingData, dealerId });
            openSnackbar('success', 'Fedex carrier updated successfully.');
        } catch (error) {
            openSnackbar('error', 'An error occurred while updating the fedex carrier. Please try again.');
        }
    }

    return {
        formik
    };
}

export default useFedexCarrier;